import { InstanceType } from "../../../../utils/Instance";
import { ActionType } from "./types";

const commonActions = [ActionType.RENAME, ActionType.DELETE];

export default {
  [InstanceType.FOLDER]: [...commonActions, ActionType.ADD_FOLDER],
  [InstanceType.RECORD]: commonActions,
};
